import { gql } from "graphql-request";

const SERVER_UPDATE_FEEDBACK = gql`
  mutation SERVER_updateFeedbackAnswer($input: [FeedbackAnswerUpdateInput!]!) {
    updateFeedbackAnswer(input: $input) {
      id
    }
  }
`;
export default SERVER_UPDATE_FEEDBACK;